import React from 'react'
import {
  Flex,
  Text,
  Box,
  Link,
  Button,
  ChakraProvider,
  Center,
} from '@chakra-ui/react'
import AnimatedText from './AnimatedText'
import ProjectBrief from './ProjectBrief'
import Contact from './Contact'

const Home = () => {
  // Fade in sideways transition effect

  const projectDetails = [
    {
      id: 1,
      src: '/bintus store pic.jpeg',
      alt: 'bintus store',
      projectLink: '/bintusstore',
      name: 'Bintus Store Clothing App',
      info: 'Bintus store clothing app is a clothing store e-commerce website. Users can create accounts to enable them make instant purchases and add items to cart to purchase in bulk or later ',
      footerInfo: 'Project completed!',
    },
    {
      id: 2,
      src: '/book app.jpeg',
      alt: 'book app',
      projectLink: '/bookapp',
      name: 'Book App',
      info: 'Book app is web application that allows registered users purchase their favorite  e-books for FREE! It allows users read,  guage progress and store for future reference',
      footerInfo: 'Project still in progress...',
    },
    {
      id: 3,
      src: '/afrotopia.png',
      alt: 'Afrotopia pic',
      projectLink: '/afrotopia',
      name: 'Afrotopia',
      info: 'Afrotopia is a fashion store site that allows registered users purchase their choice fits for exclusive occasions! Users get to pick from a range of trendy outfits exhibited by fashion icons from all over the globe!',
      footerInfo: 'Project still in progress...',
    },
  ]
  return (
    <ChakraProvider>
      <Box
        w={{
          base: '90%',
          sm: '90%',
          md: '90%',
          lg: '90%',
          xl: '90%',
        }}
        alignContent='center'
        mx='auto'
        h={{
          base: 'auto',
          sm: 'auto',
          md: 'auto',
          lg: 'auto',
          xl: 'auto',
        }}
        my={{
          base: '50px',
          sm: '50px',
          md: '100px',
          lg: '100px',
          xl: '100px',
        }}>
        <Flex
          direction={{
            base: 'column',
            sm: 'column',
            md: 'row',
            lg: 'row',
            xl: 'row',
          }}
          gap='50px'
          w='auto'>
          <Box
            w={{
              base: '100%',
              sm: '100%',
              md: '50%',
              lg: '50%',
              xl: '50%',
            }}>
            <Text
              as='b'
              fontSize={{
                base: '20px',
                sm: '20px',
                md: '35px',
                lg: '35px',
                xl: '35px',
              }}
              fontFamily='mono'
              letterSpacing='5px'>
              <AnimatedText />
              <Text>
                I'am a{' '}
                <Text
                  as='span'
                  fontWeight='extrabold'
                  fontSize={{
                    base: '20px',
                    sm: '30px',
                    md: '45px',
                    lg: '45px',
                    xl: '45px',
                  }}
                  color='Olive'>
                  Frontend Developer
                </Text>
                .
              </Text>
              <Text as='p' fontSize='20px'>
                I thrive in building solid and scalable frontend products with
                engaging user experience.
              </Text>
            </Text>
            <br />
            <hr />
            <br />
            <Text
              fontSize={{
                base: '20px',
                sm: '20px',
                md: '35px',
                lg: '35px',
                xl: '30px',
              }}
              fontFamily='Indie Flower'
              letterSpacing='5px'>
              Click the button below to checkout my Projects!{' '}
              <i class='fa-sharp fa-regular fa-hand-point-right'></i>
              <i class='fa-sharp fa-regular fa-hand-point-left'></i> <br />
              <br />
            </Text>
            <Link href='/projects'>
              <Button
                color='White'
                _hover={{ color: 'olive', bg: '#FAF0E6' }}
                bg='Olive'
                className='button'
                variant='solid'
                mx={{
                  base: '15%',
                  sm: '15%',
                  md: '30%',
                  lg: '30%',
                  xl: '20%',
                }}
                p='30px'
                w='250px'>
                PROJECTS
              </Button>
            </Link>
          </Box>
          {/* <Box
            w={{
              base: '100%',
              sm: '100%',
              md: '50%',
              lg: '50%',
              xl: '50%',
            }}>
            <Image
              src='/portfolio image.jpg'
              objectFit='contain'
              h='500px'
              w='100%'
              maxW='100%'
            />
          </Box> */}
          <div class='card__collection clear-fix'>
            <div class='cards cards--three'>
              <img src='/portfolio image.jpg' class='img-responsive' alt='' />
              <span class='cards--three__rect-1'>
                <span class='shadow-1'></span>
                <p>Bintus</p>
              </span>
              <span class='cards--three__rect-2'>
                <span class='shadow-2'></span>
              </span>
              <span class='cards--three__circle'></span>
              <ul class='cards--three__list'>
                <li>
                  <a href='https://github.com/bintus-ux' target='_blank'>
                    <i class='fab fa-github'></i>
                  </a>
                </li>
                <li>
                  <a href='https://x.com/BintusCal?s=20' target='_blank'>
                    <i class='fab fa-twitter'></i>
                  </a>
                </li>
                <li>
                  <a
                    href='https://www.linkedin.com/in/calebeze/'
                    target='_blank'>
                    <i class='fab fa-linkedin-in'></i>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </Flex>
        <Box>
          <Center>
            <Text
              fontSize={{
                base: '30px',
                sm: '30px',
                md: '35px',
                lg: '35px',
                xl: '40px',
              }}
              fontFamily='Inter'
              letterSpacing='5px'
              mt={{
                base: '10px',
                sm: '10px',
                md: '50px',
                lg: '100px',
                xl: '100px',
              }}>
              {' '}
              Projects
            </Text>
          </Center>
          <Center>
            <Text
              fontSize={{
                base: '15px',
                sm: '15px',
                md: '25px',
                lg: '25px',
                xl: '25px',
              }}
              fontFamily='Indie Flower'
              letterSpacing='5px'
              mb={{
                base: '30px',
                sm: '30px',
                md: '50px',
                lg: '100px',
                xl: '100px',
              }}
              mt={{
                base: '10px',
                sm: '10px',
                md: '50px',
                lg: '30px',
                xl: '30px',
              }}>
              {' '}
              Below is a preview of some of my most recent projects...
            </Text>
          </Center>
          <div
            className='card-container'
            direction={{
              base: 'column',
              sm: 'column',
              md: 'row',
              lg: 'row',
              xl: 'row',
            }}
            gap='30px'
            w='auto'>
            {projectDetails.map((projectDetail) => (
              <ProjectBrief projectDetail={projectDetail} />
            ))}
          </div>
        </Box>
        <Box
          my={{
            base: '50px',
            sm: '50px',
            md: '100px',
            lg: '100px',
            xl: '100px',
          }}>
          <Contact />
        </Box>
      </Box>
    </ChakraProvider>
  )
}

export default Home
